module.exports = __webpack_public_path__ + "img/icn_check_hv_taichou.fb709d97.png";